/** @format */

import React, {useContext, useEffect, useState} from 'react';
import {CheckoutAccordion, AccordionSection} from 'frontier/account/checkout_accordion';

import {CheckoutLogin} from 'frontier/account/components/auth/checkout_login';
import {Loading} from 'frontier-utilities';
import {AccountContext} from 'frontier-utilities';
import {CartOverviewSummary} from 'frontier/cart/components/cart_overview/cart_overview_summary';

import '../cart/components/cart/container.sass';
import {
    CartCheckoutContext,
    CartCheckoutContextDefault
} from 'frontier/cart/components/cart/cart_checkout_context';
import {withCartHandlerResponseToState} from 'frontier/cart/components/cart/with_cart_handler';

export function PreCheckoutAuthenticate({redirect, format}) {
    const [cartCheckoutContext, setCartCheckoutContext] = useState(CartCheckoutContextDefault);
    const ctx = useContext(AccountContext);

    const getData = async () => {
        const request = await fetch('/carts/current', {
            headers: {
                accept: 'application/json'
            }
        });
        const response = await request.json();
        if (response) {
            setCartCheckoutContext(withCartHandlerResponseToState(response));
        }
    };

    useEffect(() => {
        getData();
    }, []);

    if (ctx && ctx?.user?.is_logged_in) {
        window.location.href = '/carts';
        return <Loading />;
    } else if (ctx && ctx?.user?.is_logged_in === false)
        return (
            <CartCheckoutContext.Provider value={cartCheckoutContext}>
                <div className="checkout-container d-flex align-items-start justify-content-between">
                    <CheckoutAccordion>
                        <AccordionSection
                            title="1. Customer"
                            sectionId={cartCheckoutContext.currentStep}>
                            <CheckoutLogin redirect={redirect} format={format} />
                        </AccordionSection>
                        <AccordionSection title="2. Shipping" />
                        <AccordionSection title="3. Billing" />
                        <AccordionSection title="4. Payment" />
                    </CheckoutAccordion>

                    <div className="cart-overview-summary from-login-overview">
                        {cartCheckoutContext && <CartOverviewSummary fromLogin />}
                    </div>
                </div>
            </CartCheckoutContext.Provider>
        );
}
